module.exports = __webpack_public_path__ + "static/media/vtex10.718b006b.png";